// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1g2Ii","footer":"ModalInfo_footer__O1xfb"};